const home = {
  hero: {
    badge: "Negocio Familiar · Royal Palm Beach, FL",
    title1: "Adry & Mich",
    title2: "Cleaning & Handyman",
    title3: "Limpieza · Reparaciones · Servicio en el que Puedes Confiar",
    subtitle: "Servicios profesionales de limpieza del hogar, cuidado de mascotas y reparaciones en Royal Palm Beach, FL y sus alrededores. Tratamos tu hogar como el nuestro — resultados impecables, siempre.",
    cta1: "Cotización Gratis",
    cta2: "Ver Servicios",
    badge2: "★★★★★ 100% Satisfacción Garantizada",
  },
  services: {
    title: "Nuestros Servicios",
    subtitle: "Soluciones completas para tu hogar — limpieza y reparaciones bajo un mismo techo.",
    cleaning: {
      title: "Servicios de Limpieza",
      desc: "Limpieza profesional adaptada a las necesidades de tu hogar.",
      items: ["Limpieza Residencial", "Limpieza Profunda", "Mudanza / Entrega", "Limpieza Airbnb"],
      cta: "Ver Todos los Servicios de Limpieza →",
    },
    handyman: {
      title: "Servicios de Reparación",
      desc: "Reparaciones e instalaciones confiables para cada rincón de tu hogar.",
      items: ["Reparación de Drywall", "Reparación de Puertas", "Pintura Interior", "Instalación de TV"],
      cta: "Ver Todos los Servicios de Reparación →",
    },
  },
  why: {
    title: "¿Por Qué Elegirnos?",
    subtitle: "No somos solo un servicio — somos tus socios de confianza para el cuidado del hogar.",
    items: [
      { icon: "ri-home-heart-line", title: "Negocio Familiar", desc: "Cuidado personal y confianza en cada trabajo que realizamos." },
      { icon: "ri-focus-3-line", title: "Atención al Detalle", desc: "No tomamos atajos — cada rincón recibe la atención que merece." },
      { icon: "ri-shield-check-line", title: "Confiables y Honestos", desc: "Llegamos a tiempo y cumplimos lo que prometemos." },
      { icon: "ri-tools-line", title: "Solución Todo en Uno", desc: "Limpieza + reparaciones — sin necesidad de contratar varias empresas." },
    ],
  },
  who: {
    title: "A Quién Ayudamos",
    subtitle: "Servimos a una amplia variedad de clientes en Royal Palm Beach y alrededores.",
    items: [
      { icon: "ri-group-line", label: "Familias Ocupadas" },
      { icon: "ri-building-line", label: "Anfitriones de Airbnb" },
      { icon: "ri-home-2-line", label: "Propietarios" },
      { icon: "ri-heart-line", label: "Adultos Mayores" },
      { icon: "ri-star-line", label: "Quien Quiera un Hogar Limpio" },
    ],
  },
  testimonials: {
    title: "Lo Que Dicen Nuestros Clientes",
    subtitle: "Reseñas reales de clientes que confían en nosotros con sus hogares.",
    viewAll: "Ver Todos los Testimonios",
  },
  ctaBanner: {
    title: "¿Listo para un Hogar Impecable?",
    subtitle: "Contáctanos hoy y recibe tu cotización gratis. ¡Respondemos rápido!",
    cta1: "Llamar: (561) 262-6118",
    cta2: "Enviar WhatsApp",
  },
};

export default home;
